import { render, staticRenderFns } from "./PostCodeDialog.vue?vue&type=template&id=08e9d102&scoped=true&lang=pug&"
import script from "./PostCodeDialog.vue?vue&type=script&lang=ts&"
export * from "./PostCodeDialog.vue?vue&type=script&lang=ts&"
import style0 from "./PostCodeDialog.vue?vue&type=style&index=0&id=08e9d102&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08e9d102",
  null
  
)

export default component.exports